module.exports = {
    "0x1": "https://mainnet.infura.io/v3/YOUR_INFURA_PROJECT_ID",
    "0x61": "https://data-seed-prebsc-1-s1.binance.org:8545/",
    "0x89": "https://polygon-rpc.com/",
};